<template>
    <div v-dusk="'warning-existing-orders-not-modified'" class="warning-existing-orders-not-modified">
        <ErrorsZone :errors="errors"></ErrorsZone>

        <div v-if="loading">
            <i class="fad fa-spinner fa-spin"></i> Recherche de commandes existantes à venir pour ce jour de la semaine...
        </div>
        <template v-else-if="existingOrdersSameDay && existingOrdersSameDay.length > 0">
            <div class="alert alert-warning">
                <span class="alert-heading h4"><i class="fas fa-exclamation-triangle"></i> Attention</span>
                <p>
                    Modifier cette commande hebdomadaire automatique ne modifiera pas le contenu des commandes existantes.<br>
                    Voici les commandes qui ne seront pas modifiées :
                </p>
                <ul class="list-group">
                    <li v-for="existingOrderSameDay in existingOrdersSameDay" class="list-group-item">
                        Livraison du {{ existingOrderSameDay.date }} - <a :href="existingOrderSameDay.url">voir la commande {{ existingOrderSameDay.reference }}</a>
                    </li>
                </ul>
            </div>
        </template>
    </div>
</template>

<script>
    import ErrorsZone from "./ErrorsZone";
    import {useGetLoader} from "./compositions/axios/loadingRequest";
    import {momentDay, momentDaysAreSame} from "../moment-with-helpers"

    export default {
        name: 'WarningExistingOrdersNotModified',

        components: {
            ErrorsZone,
        },

        props: {
            side: {
                type: String,
                required: true,
            },
            customer: {
                type: Object,
                required: true,
            },
            deliveryDate: {
                type: Date,
                required: true,
            },
            editing: {
                type: Boolean,
                required: false,
                default: false,
            },
        },

        setup() {
            const {
                loaded,
                loading,
                errors,
                load,
            } = useGetLoader();

            return {
                loaded,
                loading,
                errors,
                load,
            };
        },

        data() {
            return {
                existingOrdersSameDay: {},
            };
        },

        async mounted() {
            await this.loadStateFromServer();
        },

        watch: {
            async deliveryDate(newValue, oldValue) {
                if (!momentDaysAreSame(newValue, oldValue)) {
                    await this.loadStateFromServer();
                }
            },
        },

        methods: {
            async loadStateFromServer() {
                let url = '';
                if (this.side === 'employees') {
                    url = `/espace-employes/commandes/recherche-commandes-existantes-meme-jour/client/${this.customer.id}/date/${momentDay(this.deliveryDate).format('YYYY-MM-DD')}`
                } else {
                    url = `/espace-magasins/magasin/${this.customer.id}/commandes/recherche-commandes-existantes-meme-jour/date/${momentDay(this.deliveryDate).format('YYYY-MM-DD')}`
                }
                this.existingOrdersSameDay = await this.load(url);
            },
        },
    }
</script>
